import { render, staticRenderFns } from "./dialog-window.vue?vue&type=template&id=39ba2a2e&"
import script from "./dialog-window.vue?vue&type=script&lang=js&"
export * from "./dialog-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports